import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Modal } from "antd";

import { openTutorial } from "../../../stores/nutstat";
import { fetchNutritions } from "../../../stores/nutrition";
import { responsive } from "../../../utils/style";
import PaperIcon from "../../../assets/icons/paper.svg";
import NutStat from "../../../components/Nutstat";
import { parseDateToString } from "../../../utils/date";

export const TOTAL_STEPS = [{ step: 1 }, { step: 2 }];

const Nutrition = () => {
  const { rule } = useSelector((state) => state.nutrition);
  const { showTutorial } = useSelector((state) => state.nutstat);
  const {
    informInfo: { currentWeek },
  } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const now = new Date();

  useEffect(() => {
    dispatch(fetchNutritions());

    // For show Tutorial modal
    const hideTutorial = localStorage.getItem("hideTutorial");
    if (hideTutorial !== "true") dispatch(openTutorial());
  }, []);

  return (
    <Container>
      <Background>
        <Modal visible={showTutorial} footer={null} closable={false}>
          <NutStat isStudent />
        </Modal>
        <Topic>กรอกข้อมูลภาวะโภชนาการ</Topic>
        <Inform>
          <Howto onClick={() => dispatch(openTutorial())}>
            <Image src={PaperIcon} />
            ดูวิธีเช็กภาวะโภชนาการ
          </Howto>
        </Inform>
        {TOTAL_STEPS.map((w, i) => {
          const currentDateRule = rule[w.step];
          const isActive = currentWeek && now >= currentDateRule;

          return (
            <Action
              className={isActive ? "active" : "inactive"}
              to={isActive ? `/nutrition/views/${w.step}` : ""}
              key={i}
            >
              <Label>กรอกข้อมูลภาวะโภชนาการครั้งที่ {w.step}</Label>
              <Addon>
                {`กรอกครั้งที่ ${w.step} หลังวันที่ ${parseDateToString(
                  currentDateRule
                )}`}
              </Addon>
            </Action>
          );
        })}
      </Background>
    </Container>
  );
};

export default Nutrition;

const Container = styled.div`
  width: 100%;
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;

  ${responsive.mobile(css`
    input {
      max-width: none;
    }
  `)}
`;
const Background = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1144px;
  background-color: white;
  padding: 40px 187px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.tablet(css`
    padding: 40px 24px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px;
  `)}
`;
const Topic = styled.h5`
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: #058459;
  text-align: center;
  margin-bottom: 46px;
`;
const Inform = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 770px;
  margin-bottom: 15px;

  ${responsive.tablet(css`
    width: 100%;
  `)}
`;
const Howto = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #4b5768;

  &:hover {
    cursor: pointer;
  }
`;
const Action = styled(Link)`
  width: 770px;
  height: 120px;
  background: #e7eaee;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 23px;
  padding-bottom: 23px;

  ${responsive.tablet(css`
    width: 100%;
  `)}

  &.active {
    background: #fc6b4b;
    &:hover {
      cursor: pointer;
    }

    > h4,
    span {
      color: #ffffff;
    }
  }

  &.inactive {
    &:hover {
      cursor: not-allowed;
    }
  }
`;
const Label = styled.h4`
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: #a0abbb;

  > br {
    display: none;
  }

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;
    > br {
      display: block;
    }
  `)}
`;
const Addon = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #a0abbb;

  ${responsive.mobile(css`
    font-size: 13px;
    line-height: 14px;
  `)}
`;
const Image = styled.img``;
